import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import useSWR from "swr";

import { getSettingState } from "../../../../../redux/features/settingSlice";
import CustomAvatar from "../../../CustomAvatar";

const EditProfileImageUploader = () => {
  const { userData, localAvatar } = useSelector(getSettingState);

  const { data: profile } = useSWR(() => {
    if (!userData) {
      return null;
    }
    return `${process.env.REACT_APP_API}/auth/profile/${userData}/`;
  });

  return (
    <Box
      sx={{
        mt: "64px",
        pt: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "60px",
      }}
    >
      <CustomAvatar
        size={64}
        src={localAvatar ? localAvatar : profile?.avatar}
        alt={profile?.nickname}
      />

      <Typography
        sx={{
          fontSize: "20px",
          mt: "16px",
          fontWeight: "400",
          paddingTop: "4px",
          cursor: "pointer",
          textAlign: "center",
        }}
      >
        Choose an avatar or upload a photo
        <br /> from your device.
      </Typography>
    </Box>
  );
};

export default EditProfileImageUploader;
